import { CommonModule } from "@angular/common";
import { Component, input, computed } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

export type ChipVariant =
  | "primary-blue"
  | "secondary-blue"
  | "orange"
  | "yellow"
  | "red"
  | "green"
  | "gray";

@Component({
  selector: "app-chip",
  imports: [CommonModule, MatIconModule],
  templateUrl: "./chip.component.html",
  styleUrls: ["./chip.component.scss"],
})
export class ChipComponent {
  readonly label = input<string>();
  readonly variant = input<ChipVariant>("primary-blue");
  readonly iconStart = input<string>();
  readonly iconEnd = input<string>();
  readonly iconOnly = input<boolean>(false);
  readonly iconType = input<"outlined" | "filled">("outlined");

  readonly chipClass = computed(() => {
    return `chip-${this.variant()}`;
  });

  readonly iconClass = computed(() => {
    if (this.iconType() === "outlined") {
      return "material-icons-outlined";
    }
    return "material-icons";
  });
}
